import React, { Component } from "react";
import classnames from "classnames";

import { ITestableComponentProps } from "@formant/core/model/ITestableComponentProps";
import { Icon, IconName } from "@formant/ui/component/common/Icon";

import { Button } from "../common/Button";
import * as styles from "./IconButton.scss";

export interface IIconButtonProps extends ITestableComponentProps {
    to: string;
    onClicked?: () => void;
    icon: IconName;
    className?: string;
    children?: React.ReactNode;
}

export class IconButton extends Component<IIconButtonProps> {
    public render() {
        const { to, onClicked, icon, className, children } = this.props;
        return (
            <Button
                to={to}
                onClicked={onClicked}
                className={classnames(
                    styles["icon-button"],
                    styles.button,
                    className,
                )}
                data-testid={this.props["data-testid"]}
            >
                <Icon name={icon} />
                {children}
            </Button>
        );
    }
}
